module.exports = __webpack_public_path__ + "static/img/6.1eec5c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/6.png
// module id = JKjq
// module chunks = 0